<template src="./template.html"/>
<script>
    export default {
        name: 'thanks',
        mounted() {
            gtag('event', 'conversion', {'send_to': 'AW-701701549/X4ojCNy08rABEK27zM4C'});
            console.log("Page mounted !!");
        }
    }
</script>
<style scoped src="../404/styles.css"/>
